import { Input, Pagination, Spin } from 'antd'
import { useState } from 'react'
import { FaSearch } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import unidecode from 'unidecode'
import { PostDTO } from '../../../api/dto'
import { cn } from '../../../utils/helper'
import ContestantCard from './ContestantCard'
import { useTranslation } from 'react-i18next'

type Props = {
    contestants: PostDTO[]
}

const pageSize = 8

export default function DataListNew({ contestants }: Props) {
    const [data, setData] = useState(contestants)
    const [currentPage, setCurrentPage] = useState(1)
    const [imagesLoaded, setImagesLoaded] = useState(0)
    const [searchValue, setSearchValue] = useState('')
    const navigate = useNavigate()
    const { t } = useTranslation('ContestantList')

    function handlePaginate(page: number) {
        setCurrentPage(page)
        setImagesLoaded(0)
    }

    function handleSearchChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.value
        setSearchValue(value)
        const filteredData = contestants.filter((contestant) =>
            unidecode(contestant.name).toLowerCase().includes(unidecode(value).toLowerCase().trim())
        )
        setData(filteredData)
        setCurrentPage(1)
        setImagesLoaded(0)
    }

    const paginatedData = data.slice((currentPage - 1) * pageSize, (currentPage - 1) * pageSize + pageSize)
    const finishedLoading = imagesLoaded === paginatedData.length

    return (
        <div>
            <div className="mb-5">
                <Input
                    type="text"
                    onChange={handleSearchChange}
                    placeholder={t('Search by name')}
                    prefix={<FaSearch className="text-white/50" />}
                    classNames={{
                        input: 'bg-transparent border-2 text-white placeholder:text-white h-full pl-2',
                        affixWrapper: 'bg-transparent'
                    } as any}
                />
            </div>
            {!finishedLoading && (
                <div className="col-span-4 row-span-2 grid h-[70vh] w-full place-items-center bg-[#010a1b]">
                    <div className="flex flex-col gap-5">
                        <Spin size="large" />
                        <span className="text-2xl font-bold">{t('Loading data')}</span>
                    </div>
                </div>
            )}
            <div className={cn('grid grid-cols-2 items-center gap-5 lg:grid-cols-4', !finishedLoading && 'hidden')}>
                {paginatedData.map((contestant, index) => (
                    <ContestantCard
                        index={index}
                        post={contestant}
                        key={searchValue + '-' + contestant._id}
                        onClick={() => navigate(contestant._id)}
                        finishedLoading={finishedLoading}
                        onLoad={() => {
                            setImagesLoaded((prev) => prev + 1)
                        }}
                    />
                ))}
            </div>
            <Pagination current={currentPage} onChange={handlePaginate} total={data.length} pageSize={pageSize} className="mt-5" />
        </div>
    )
}
